import { Audio, useVideoConfig } from "remotion";
import type { AudioItem as AudioItemType } from "../../../types";

export const AudioItem = ({ item }: { item: AudioItemType }) => {
  if (item.type !== "audio") {
    throw new Error("Item is not an audio item");
  }

  const { fps } = useVideoConfig();

  return (
    <Audio
      src={item.src}
      startFrom={item.audioStartFromInSeconds * fps}
      volume={1}
      playbackRate={1}
      loop
    />
  );
};
